'use strict';exports.__esModule = true;
var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);

var _Icons = require('./Icons');var _Icons2 = _interopRequireDefault(_Icons);

var _FeaturesIcons = require('./FeaturesIcons.scss');var styles = _interopRequireWildcard(_FeaturesIcons);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };} // Helpers
// Modules
var FeaturesIcons = function FeaturesIcons(properties) {
  var content = (0, _Icons2.default)(properties.translate).map(function (item) {var _cx;return (
      _react2.default.createElement('div', { className: (0, _classnames2.default)(styles.iconContainer, (_cx = {}, _cx[styles.highlighted] = !properties.isMobileOrTablet, _cx)), key: item.id },
        _react2.default.createElement('div', null, item.icon),
        _react2.default.createElement('div', { className: styles.title }, item.title)));});


  return (
    _react2.default.createElement('div', { className: styles.featuresIcons },
      content));


}; // Styles
exports.default =
FeaturesIcons;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/FeaturesIcons/FeaturesIcons.js
// module id = 2631
// module chunks = 0